// extracted by mini-css-extract-plugin
module.exports = {"iconArrowSvg":"IconArrowSvg_iconArrowSvg__IdAU1","iconArrowSvg__path":"IconArrowSvg_iconArrowSvg__path__rtdky"};